import React from "react";
import { getLanguageFile } from "./GetLanguageFile";

const LoadingExp = () => {
  return (
    <div
      className="pulse"
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <span>{getLanguageFile("generics.loading")}</span>

      {/* <div
        style={{
          width: "100%",
          height: "2px",
          opacity: ".6",
          background: "#f2f3f440",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            height: "100%",
            width: `${ downloadPercentage * 100 : 100} }%`,
            transition: "all 50ms ease-in-out",
            background: "#f2f3f4",
          }}
        />
      </div> */}
    </div>
  );
};

export default LoadingExp;
